import React from 'react';
import PropTypes from 'prop-types';

import UsersApi from 'apis/Users';
import { getUserId, clear } from 'constants/localStorageManager';
import 'assets/scss/soonoGetStarted.css';
import 'assets/scss/confirmation-modal.css';

import ConfirmationEmailDashboard from './ConfirmationEmailDashboard';
import UpdateEmail from './UpdateEmail';
import EmailConfirmationSent from './EmailConfirmationSent';
import Toaster from '../../Toaster';

class ModalDisplay extends React.Component {
  constructor() {
    super();
    this.state = {
      isEmailConfirmationVisible: true,
      isEmailUpdateVisible: false,
      isConfirmationSentVisible: false,
      formValues: {
        updateEmail: {},
        confirmEmail: {},
      },
    };
  }

  componentDidUpdate(prevProps) {
    const { displayConfirmation } = this.props;
    if (
      displayConfirmation &&
      displayConfirmation !== prevProps.displayConfirmation
    )
      this.displayEmailConfirmation();
  }

  displayEmailConfirmation = () => {
    this.setState({ isEmailConfirmationVisible: true });
  };

  toggleEmailConfirmation = () => {
    this.setState(({ isEmailConfirmationVisible }) => ({
      isEmailConfirmationVisible: !isEmailConfirmationVisible,
      isEmailUpdateVisible: false,
      isConfirmationSentVisible: false,
    }));
  };

  toggleConfirmationSent = email => {
    this.setState(({ isConfirmationSentVisible }) => ({
      isConfirmationSentVisible: !isConfirmationSentVisible,
      isEmailUpdateVisible: false,
      isEmailConfirmationVisible: false,
      email,
    }));
  };

  toggleEmailUpdate = () => {
    this.setState(({ isEmailUpdateVisible }) => ({
      isEmailUpdateVisible: !isEmailUpdateVisible,
      isEmailConfirmationVisible: false,
      isConfirmationSentVisible: false,
    }));
  };

  closeAllModal = () => {
    this.setState({
      isEmailUpdateVisible: false,
      isEmailConfirmationVisible: false,
      isConfirmationSentVisible: false,
    });
  };

  resendConfirmation = () => {
    const { loginScreen, email } = this.props;
    UsersApi.resendConfirmation(email)
      .then(({ data }) => {
        const { email } = data;

        this.setState({ email });
        this.toggleConfirmationSent();
        if (loginScreen) clear();
        Toaster.getSuccessToaster(
          'check-circle',
          'Confirmation email sent successfully'
        );
      })
      .catch((e) => {
        console.log(e)
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Error while sending confirmation email'
        );
      });
  };

  handelToggleModal = () => {
    this.closeAllModal();
    this.props.handleModalClosed();
  };

  render() {
    const { displayConfirmation, email: defaultEmail } = this.props;
    const {
      isEmailConfirmationVisible,
      isConfirmationSentVisible,
      isEmailUpdateVisible,
      formValues,
      email,
    } = this.state;

    const displayEmail = email || defaultEmail;

    if (!displayConfirmation) return null;

    return (
      <React.Fragment>
        <ConfirmationEmailDashboard
          isVisible={isEmailConfirmationVisible}
          toggleModal={this.handelToggleModal}
          toggleEmailUpdate={this.toggleEmailUpdate}
          resendConfirmation={this.resendConfirmation}
        />
        <UpdateEmail
          isVisible={isEmailUpdateVisible}
          toggleModal={this.handelToggleModal}
          toggleEmailConfirmation={this.toggleEmailConfirmation}
          toggleEmailConfirmationSent={this.updateEmail}
          toggleConfirmationSent={this.toggleConfirmationSent}
          email={displayEmail}
        />
        <EmailConfirmationSent
          email={displayEmail}
          isVisible={isConfirmationSentVisible}
          toggleModal={this.handelToggleModal}
        />
      </React.Fragment>
    );
  }
}

ModalDisplay.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
};

export default ModalDisplay;



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/Modal/ModalDisplay.js